// Auto-generated by forge/extract-bytecodes.ts — DO NOT EDIT
// Source: forge/out/IdentityRegistry.sol/IdentityRegistry.json

export const IDENTITY_REGISTRY_ABI = [
  {
    "type": "function",
    "name": "getAgentAddress",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getAgentId",
    "inputs": [
      {
        "name": "agent",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getIdentity",
    "inputs": [
      {
        "name": "agent",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "uri",
        "type": "string",
        "internalType": "string"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isFrozen",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isRegistered",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isRegistered",
    "inputs": [
      {
        "name": "agent",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "nextAgentId",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "register",
    "inputs": [
      {
        "name": "agent",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "uri",
        "type": "string",
        "internalType": "string"
      }
    ],
    "outputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setFrozen",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "frozen",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "updateIdentity",
    "inputs": [
      {
        "name": "uri",
        "type": "string",
        "internalType": "string"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "event",
    "name": "Registered",
    "inputs": [
      {
        "name": "agent",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "uri",
        "type": "string",
        "indexed": false,
        "internalType": "string"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Updated",
    "inputs": [
      {
        "name": "agent",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "uri",
        "type": "string",
        "indexed": false,
        "internalType": "string"
      }
    ],
    "anonymous": false
  }
] as const;

export const IDENTITY_REGISTRY_BYTECODE = "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" as const;
